import { ReactNode } from "react";
import { Box, ButtonBase, styled, SxProps } from "@mui/material";

const Button = styled(ButtonBase)(({ theme }) => ({
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: theme.vars.palette.divider,
  borderRadius: "22px",
  gap: "6px",
}));

const IconWrapper = styled(Box)(() => ({
  borderRadius: "50%",
  margin: "1px",
  "& > svg": {
    height: "20px",
    width: "20px",
    display: "block",
  },
}));

const CheckedIcon = styled(IconWrapper)(({ theme }) => ({
  backgroundColor: theme.vars.palette.borders.neutral.subtle,
}));

const UncheckedIcon = styled(IconWrapper)(() => ({
  backgroundColor: undefined,
}));

const padding = {
  large: "10px",
  medium: "6px",
};

const gap = {
  large: "6px",
  medium: "2px",
};

const borderRadius = {
  large: "22px",
  medium: "18px",
};

type IconSwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  onIcon: ReactNode;
  offIcon: ReactNode;
  label: string;
  size?: "medium" | "large";
  sx?: SxProps;
};

export function IconSwitch({
  checked,
  onChange,
  onIcon,
  offIcon,
  label,
  size = "medium",
  sx = {},
}: IconSwitchProps) {
  const First = checked ? CheckedIcon : UncheckedIcon;
  const Second = checked ? UncheckedIcon : CheckedIcon;

  return (
    <Button
      onClick={() => onChange(!checked)}
      sx={{ gap: gap[size], borderRadius: borderRadius[size], ...sx }}
      aria-label={label}
    >
      <First padding={padding[size]}>{onIcon}</First>
      <Second padding={padding[size]}>{offIcon}</Second>
    </Button>
  );
}
